<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>QnA</h2>
            </div>
            <article class="view cmnity">
                <div class="search_box">
                    <p>총 게시물<strong> {{ qnaList.length }}</strong>건</p>
                    <div class="form_inline">
                        <input type="text" class="form_control" v-model="searchInfo.searchWord" placeholder="검색어를 입력하세요.">
                        <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                        <button 
                            class="btn btn_md btn_brown"
                            @click="fn_qna_write">
                            QnA 등록
                        </button>
                    </div>
                </div>
                <div class="tab_contents">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list">
                                <colgroup>
                                    <col width="150">
                                    <col width="*">
                                    <col width="200">
                                    <col width="100">
                                    <col width="100">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>제목</th>
                                        <th>작성일자</th>
                                        <th>작성자</th>
                                        <th>상태</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="(item, index) in qnaList" :key="index"
                                        @click="fn_move_qna_detail(item)"
                                    >
                                        <td><span>{{ item.no ? item.no : index + 1}}</span></td>
                                        <td class="al">
                                            <span>{{ item.qna_title }}</span>
                                            <i class="icon icon_lock ml10" v-if="item.scret_yn == 'Y'"></i>
                                        </td>
                                        <td><span>{{ item.reg_dt }}</span></td>
                                        <td><span>{{ item.doctor_nm }}</span></td>
                                        <td>
                                            <span v-if="item.qna_status == 'RQ'">응답대기중</span>
                                            <span v-if="item.qna_status == 'RS'">응답완료</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
                    </div>
                </div>
            </article>
                       
        </section>

        <qnaPasswordCheckModal 
            :title="'비빌번호체크'"
            :qna_seq="qna_seq"
            @callback="fn_move_qna_scret_detail"
        />
        <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        :closeEventValue="closeEventValue"
        @closeEvent="oncCloseEvent"
        v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import qnaPasswordCheckModal from '@/modal/user/qnaPasswordCheckModal.vue'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    export default {
        components: {
            Pagination,
            qnaPasswordCheckModal,
            AlertModal
        },
        mixins: [alertutill],
        data () {
            return {
                clinicDoctorId : '',
                searchInfo : {
                    searchWord : '',
                    pageInfo : {
                        page : 1,
                        pageSize : 10,
                        totPage : 0
                    }                
                },
                pagingShow : false,
                navTitle: ['커뮤니티', 'QnA'], 
                qnaList: [],
                qna_seq : '',
            }
        },
        mounted(){
            this.clinicDoctorId = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

            this.fn_search();
        },
        methods : {
            fn_qna_write(){

                if(this.clinicDoctorId != ''){
                    this.$router.push('/qnaWrite');
                }else{
                    let msg = "로그인이 필요합니다. \n 로그인 화면으로 이동합니다.";
                    this.fn_open_alert_close(msg);
                }
            },
            fn_search(){
                axios
                    .post("/api/user/board/getQnaList", this.searchInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.qnaList = res.data.qnaList;

                        console.log("@@@@ qnaList : %o",this.qnaList);

                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchInfo.pageInfo.totPage> 0){
                            this.pagingShow = true;                          
                        }                        

                    })
                    .catch((err) => console.log(err));
            },
            fn_move_qna_detail(obj){
                if(obj.scret_yn == 'Y'){
                    if(this.clinicDoctorId == obj.question_reg_id){
                        this.qna_seq = String(obj.qna_seq);
                        this.$bvModal.show("qnaPasswordCheckModal");
                    }else{
                        let msg = "본인글이 아닙니다.";
                        this.fn_open_alert(msg); 
                        return;
                    }
                }else{
                    this.$router.push({ name: 'QnaDetail', params: { id: obj.qna_seq } });
                }
            },
            fn_move_qna_scret_detail(chkResult){

                this.$bvModal.hide("qnaPasswordCheckModal");

                if(chkResult){
                    this.$router.push({ name: 'QnaDetail', params: { id: this.qna_seq } });
                }else{
                    let msg = "비밀번호가 틀립니다.";
                    this.fn_open_alert(msg); 
                    return;
                }
            },
            oncCloseEvent(){
                this.$router.push('/login');
            } 
        },
        
    }
</script>